import styles from './apply.module.css';
import Button from '../../button/button';
const Apply = () => {
    return (
        <section className={`${styles.ctn} sm5-active-section sm5-active-fade-in-element`} id={`sm5-active5`} >
          <img
            className={`${styles.productImg} sm5-active-desktop`}
            src={`https://bucket.zhiyun-tech.com/detail/sm5challenge-creators-club-sm5.png`}
            alt=""
          />
        <div className={`${styles.contentBox} sm5-active-desktop`}>
          <h2>
            APPLY FOR <span>FREE</span> SMOOTH 5
          </h2>
          <h5>• Join ZHIYUN Creators Club.</h5>
          <h5>• Chance to Test the Latest SMOOTH 5 for Free.</h5>
          <h5>• Get Future Products {"&"} Paid Projects.</h5>
  
          <div className={styles.buttons}>
            <Button type="colorful" href="https://explore.zhiyun-tech.com/en/club/project/detail/163841475979924" target="_blank">Apply Now</Button>
            <Button type="general" href="https://www.zhiyun-tech.com/en/product/detail/490">Learn more about SMOOTH 5</Button>
          </div>
        </div>
  
        <div className={`${styles.contentBox} sm5-active-mobile`}>
          <div className={styles.mobileHeader}>
              <img
                className={styles.productImg}
                src={`https://bucket.zhiyun-tech.com/detail/sm5challenge-creators-club-sm5.png`}
                alt=""
              />
            <h2>
              APPLY FOR <br /><span>FREE</span> <br />SMOOTH 5
            </h2>
          </div>
  
          <h5>• Join ZHIYUN Creators Club.</h5>
          <h5>• Chance to Test the Latest SMOOTH 5 for Free.</h5>
          <h5>• Get Future Products {"&"} Paid Projects.</h5>
  
          <div className={styles.buttons}>
            <Button type="colorful" href="https://explore.zhiyun-tech.com/en/club/project/detail/163841475979924" target="_blank">Apply Now</Button>
  
            <Button type="general" href="https://www.zhiyun-tech.com/en/product/detail/490">Learn more about SMOOTH 5</Button>
          </div>
        </div>
      </section>
    )
}

export default Apply